
<div class="container-fluid p-3" id="projectTimeOff">
    <form>
        <div class="row">
            <div class="form-group col-md-12" id="Level1">

                <label class="level font-weight-bolder">
                    {{ 'Level' | localize }} 1<span class="required text-danger"></span>
                </label>
                <div id="levelOne">
                    <ng-select class="width-percent-100 p-0" autocomplete="off" name="Level1Approver" [(ngModel)]="Level1Approver"
                               [multiple]="false" (change)="emitdata()"
                               [ngClass]="{ 'red-border': !Level1Approver && projectFormSubmitted }"
                               #levelOne="ngModel"
                               placeholder="{{'SelectApprover' | localize}}">
                        <ng-option [value]="item" *ngFor="let item of filteredUsers; trackBy: trackByName">
                            <div class="d-flex">
                                <div class="d-flex justify-content-center align-items-center rounded bg-light mx-1">
                                    <img src="{{ item.profileImage ? item.profileImage : 'assets/common/images/default-profile-picture1.svg' }}"
                                         class="img-fluid border border-light rounded h-40px w-40px p-1" id="profimgsize">
                                </div>

                                <div class="justify-content-center ml-2 mr-4 ">
                                    <div class=" font-weight-bold font-size-13">
                                        <span pTooltip="{{ item?.name}} {{item?.surname}}"
                                              [tooltipDisabled]="item.name?.length < 17"
                                              tooltipPosition="bottom">{{ item?.name.length > 17  ? item?.name?.slice(0,17)+'...': item?.name +' ' +item?.surname|titlecase}}</span>

                                    </div>

                                    <div class="flex-column justify-content-start align-self-center font-weight-bold font-size-14" pTooltip="{{  item.emailAddress}}"
                                         [tooltipDisabled]="item.emailAddress?.length<28"
                                         tooltipPosition="bottom">

                                        {{ item.emailAddress.length>28 ? item.emailAddress.slice(0,28)+'...': item.emailAddress}}
                                    </div>
                                </div>
                            </div>
                        </ng-option>
                        <ng-template ng-label-tmp let-item="item">
                            <span class="d-flex align-items-center">
                                <img class="mr-1 w-35px h-35px img-fluid rounded bg-primary-o-40 p-1"
                                     [src]="item.profileImage ? item.profileImage : 'assets/common/images/default-profile-picture1.svg'" />
                                {{item.name}}
                            </span>
                        </ng-template>
                    </ng-select>
                    <div *ngIf="!Level1Approver && projectFormSubmitted" class="text-danger font-12" id="error-message">
                        <span>{{'Level1approverisrequired'| localize}}</span>
                    </div>
                </div>
                <div class="mt-3 text-muted">{{'ApprovalWindow' | localize}}<span class="required text-danger"></span> </div>
                <div class="d-flex">

                    <!--approval window-->
                    <div class="w-100">
                        <div class="">
                            <input type="number" autocomplete="off" (keypress)="onlyNumberKey($event)" class="form-control" required
                                   name="apprWin1" (input)="emitdata()" min="0" #apprWin1="ngModel" placeholder="{{'Select Approval' | localize}}"
                                   [(ngModel)]="projectTimeOff.approvalWindowOne"
                                   [ngClass]="{ 'red-border': !projectTimeOff.approvalWindowOne && projectFormSubmitted && !Level1Approver?.id }">

                        </div>
                        <div id="error-message" class="text-danger" *ngIf="!projectTimeOff.approvalWindowOne && projectFormSubmitted && !Level1Approver?.id">{{'ApprovalWindowismandatory' | localize}}</div>

                    </div>

                    <label class="pr-4 pl-4 pt-2">{{'in' | localize }}</label>

                    <div class="w-100" id="window">
                        <!--approval window type-->
                        <ng-select [items]="WindowEnum" autocomplete="off" bindValue="id" bindLabel="name"
                                   [(ngModel)]="projectTimeOff.approvalWindowInOne"
                                   [ngClass]="{ 'red-border': !projectTimeOff.approvalWindowInOne && projectFormSubmitted  && !Level1Approver?.id }"
                                   placeholder="{{'SelectWindowType' | localize}}" (change)="emitdata()" required>
                            <ng-template ng-option-tmp let-item="item">
                                {{item?.name | localize}}
                            </ng-template>
                        </ng-select>
                        <div id="error-message" class="text-danger " *ngIf="!projectTimeOff.approvalWindowInOne && projectFormSubmitted  && !Level1Approver?.id">{{'WindowTypeismandatory' | localize}}</div>
                    </div>
                </div>

                <div *ngIf="Level1Approver != null" class="border p-2 mt-5 rounded">

                    <div class="row">
                        <div class="col-2 d-flex justify-content-center align-items-center rounded w-40px h-40px">
                            <img src="{{ Level1Approver.profileImage ? Level1Approver.profileImage : 'assets/common/images/default-profile-picture1.svg' }}"
                                 class="w-35px h-35px img-fluid rounded border border-light p-1" id="profimgsize">
                        </div>
                        <div class=" col-9 d-flex align-items-start justify-content-center flex-column text-dark-75">
                            <div class="font-weight-bold " pTooltip="{{ getFullname(Level1Approver?.name, Level1Approver.surname) }}" [tooltipDisabled]="false"
                                 tooltipPosition="bottom">{{ getFullname(Level1Approver.name, Level1Approver.surname) | slice:0:25}}{{getFullname(Level1Approver.name, Level1Approver.surname).length > 25 ? '...' : ''}}</div>

                            <div pTooltip="{{ Level1Approver.emailAddress }}" tooltipPosition="bottom" class="div-styl2"
                                 [tooltipDisabled]="(Level1Approver.emailAddress) | tooltipDisabled:25">{{  Level1Approver.emailAddress  | slice:0:25}}{{  Level1Approver.emailAddress?.length > 25 ? '...' : '' }}</div>
                        </div>
                        <div class="col-1 px-0 py-3 cursor-pointer">
                            <img class="cursor-pointer" (click)="Level1Approver=null;emitdata()"
                                 src="assets/common/images/projects/Delete_Icon.svg" width="15" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group col-md-12" id="Level2" *ngIf="displayLevel > 1 || Level2Approver && projectTimeOff.approvalWindowTwo && projectTimeOff.approvalWindowInTwo">

                <label class="level font-weight-bolder">
                    {{ 'Level' | localize }} 2<span class="required text-danger"></span>
                </label>
                <div class="float-right rigth-div cursor-pointer" style="z-index: 6;">
                    <button type="button" (click)="removeAprroverLevel();Level2Approver=null;emitdata()"
                            class="border-0 text-danger">
                        <i class="la la-times text-danger font-weight-bold"></i>
                    </button>
                </div>
                <!--Level one approver dropdown-->
                <div id="levelOne">
                    <ng-select class="width-percent-100 p-0" name="Level2Approver" [(ngModel)]="Level2Approver"
                               [multiple]="false" (change)="emitdata()"
                               [ngClass]="{ 'red-border': !Level2Approver && projectFormSubmitted }"
                               #levelTwo="ngModel"
                               placeholder="{{'SelectApprover' | localize}}">
                        <ng-option [value]="item" *ngFor="let item of filteredUsers; trackBy: trackByName">
                            <div class="d-flex">
                                <div class="d-flex justify-content-center align-items-center rounded bg-light mx-1">
                                    <img src="{{ item.profileImage ? item.profileImage : 'assets/common/images/default-profile-picture1.svg' }}"
                                         class="img-fluid border border-light rounded h-40px w-40px p-1" id="profimgsize">
                                </div>

                                <div class="justify-content-center ml-2 mr-4 ">
                                    <div class=" font-weight-bold font-size-13">
                                        <span pTooltip="{{ item?.name}} {{item?.surname}}"
                                              [tooltipDisabled]="item?.name?.length < 17"
                                              tooltipPosition="bottom">{{ item?.name?.length > 17  ? item?.name?.slice(0,17)+'...': item?.name +' ' +item?.surname|titlecase}}</span>

                                    </div>

                                    <div class="flex-column justify-content-start align-self-center font-weight-bold font-size-14" pTooltip="{{  item?.emailAddress}}"
                                         [tooltipDisabled]="item?.emailAddress?.length<28"
                                         tooltipPosition="bottom">

                                        {{ item?.emailAddress?.length>28 ? item?.emailAddress.slice(0,28)+'...': item?.emailAddress}}
                                    </div>
                                </div>
                            </div>
                        </ng-option>
                        <ng-template ng-label-tmp let-item="item">
                            <span class="d-flex align-items-center">
                                <img class="mr-1 w-35px h-35px img-fluid rounded bg-primary-o-40 p-1"
                                     [src]="item?.profileImage ? item.profileImage : 'assets/common/images/default-profile-picture1.svg'" />
                                {{item?.name}}
                            </span>
                        </ng-template>
                    </ng-select>
                    <div *ngIf="!Level2Approver && projectFormSubmitted" class="text-danger font-size-sm">
                        <span>{{'Leveltwoapproverisrequired'| localize}}</span>
                    </div>
                </div>
                <div class="mt-3 text-muted">{{'ApprovalWindow' | localize}}<span class="required text-danger"></span> </div>
                <div class="d-flex">
                    <!--approval window-->
                    <div class="w-100">
                        <div class="">
                            <input type="number" (keypress)="onlyNumberKey($event)" class="form-control" required
                                   name="apprWin2" (input)="emitdata()" min="0" #apprWin2="ngModel" placeholder="{{'Select Approval' | localize}}"
                                   [(ngModel)]="projectTimeOff.approvalWindowTwo"
                                   [ngClass]="{ 'red-border': !projectTimeOff.approvalWindowTwo && projectFormSubmitted && !Level2Approver?.id }">
                        </div>
                        <div id="error-message" class="text-danger font-size-sm" *ngIf="!projectTimeOff.approvalWindowTwo && projectFormSubmitted && !Level2Approver?.id">{{'ApprovalWindowismandatory'| localize}}</div>

                    </div>

                    <label class="pr-4 pl-4 pt-2">{{'in' | localize }}</label>

                    <div class="w-100" id="window">
                        <!--approval window type-->
                        <ng-select [items]="WindowEnum" bindValue="id" bindLabel="name"
                                   [(ngModel)]="projectTimeOff.approvalWindowInTwo"
                                   [ngClass]="{ 'red-border': !projectTimeOff.approvalWindowInTwo && projectFormSubmitted  && !Level2Approver?.id }"
                                   placeholder="{{'SelectWindowType' | localize}}" (change)="emitdata()" required>
                            <ng-template ng-option-tmp let-item="item">
                                {{item?.name | localize}}
                            </ng-template>
                        </ng-select>
                        <div id="error-message" class="text-danger font-size-sm" *ngIf="!projectTimeOff.approvalWindowInTwo && projectFormSubmitted  && !Level2Approver?.id">{{'WindowTypeismandatory' | localize}}</div>

                    </div>
                </div>

                <div *ngIf="Level2Approver != null" class="border p-2 mt-5 rounded">

                    <div class="row">
                        <div class="col-2 d-flex justify-content-center align-items-center rounded w-40px h-40px">
                            <img src="{{ Level2Approver?.profileImage ? Level2Approver?.profileImage : 'assets/common/images/default-profile-picture1.svg' }}"
                                 class="w-35px h-35px img-fluid rounded border border-light p-1" id="profimgsize">
                        </div>
                        <div class=" col-9 d-flex align-items-start justify-content-center flex-column text-dark-75">
                            <div class="font-weight-bold " pTooltip="{{ getFullname(Level2Approver?.name, Level2Approver?.surname) }}" [tooltipDisabled]="false"
                                 tooltipPosition="bottom">{{ getFullname(Level2Approver?.name, Level2Approver?.surname) | slice:0:25}}{{getFullname(Level2Approver?.name, Level2Approver?.surname).length > 25 ? '...' : ''}}</div>

                            <div pTooltip="{{ Level2Approver?.emailAddress }}" tooltipPosition="bottom" class="div-styl2"
                                 [tooltipDisabled]="(Level2Approver?.emailAddress) | tooltipDisabled:25">{{  Level2Approver?.emailAddress  | slice:0:25}}{{  Level2Approver?.emailAddress?.length > 25 ? '...' : '' }}</div>
                        </div>
                        <div class="col-1 px-0 py-3 cursor-pointer">
                            <img class="cursor-pointer" (click)="Level2Approver=null;emitdata()"
                                 src="assets/common/images/projects/Delete_Icon.svg" width="15" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group col-md-12" id="Level3" *ngIf="displayLevel > 2 || Level3Approver && projectTimeOff.approvalWindowThree && projectTimeOff.approvalWindowInThree">

                <label class="level font-weight-bolder">
                    {{ 'Level' | localize }} 3<span class="required text-danger"></span>
                </label>
                <div class="float-right rigth-div cursor-pointer" style="z-index: 6;">
                    <button type="button" (click)="removeAprroverLevel(); Level3Approver=null;emitdata()"
                            class="border-0 text-danger">
                        <i class="la la-times text-danger font-weight-bold"></i>
                    </button>
                </div>
                <!--Level one approver dropdown-->
                <div id="levelOne">
                    <ng-select class="width-percent-100 p-0" name="Level3Approver" [(ngModel)]="Level3Approver"
                               [multiple]="false" (change)="emitdata()"
                               [ngClass]="{ 'red-border': !Level3Approver && projectFormSubmitted }"
                               #levelTwo="ngModel"
                               placeholder="{{'SelectApprover' | localize}}">
                        <ng-option [value]="item" *ngFor="let item of filteredUsers; trackBy: trackByName">
                            <div class="d-flex">
                                <div class="d-flex justify-content-center align-items-center rounded bg-light mx-1">
                                    <img src="{{ item?.profileImage ? item?.profileImage : 'assets/common/images/default-profile-picture1.svg' }}"
                                         class="img-fluid border border-light rounded h-40px w-40px p-1" id="profimgsize">
                                </div>

                                <div class="justify-content-center ml-2 mr-4 ">
                                    <div class=" font-weight-bold font-size-13">
                                        <span pTooltip="{{ item?.name}} {{item?.surname}}"
                                              [tooltipDisabled]="item?.name?.length < 17"
                                              tooltipPosition="bottom">{{ item?.name?.length > 17  ? item?.name?.slice(0,17)+'...': item?.name +' ' +item?.surname|titlecase}}</span>

                                    </div>

                                    <div class="flex-column justify-content-start align-self-center font-weight-bold font-size-14" pTooltip="{{  item?.emailAddress}}"
                                         [tooltipDisabled]="item?.emailAddress?.length<28"
                                         tooltipPosition="bottom">

                                        {{ item?.emailAddress?.length>28 ? item?.emailAddress.slice(0,28)+'...': item?.emailAddress}}
                                    </div>
                                </div>
                            </div>
                        </ng-option>
                        <ng-template ng-label-tmp let-item="item">
                            <span class="d-flex align-items-center">
                                <img class="mr-1 w-35px h-35px img-fluid rounded bg-primary-o-40 p-1"
                                     [src]="item?.profileImage ? item?.profileImage : 'assets/common/images/default-profile-picture1.svg'" />
                                {{item?.name}}
                            </span>
                        </ng-template>
                    </ng-select>
                    <div *ngIf="!Level3Approver && projectFormSubmitted" class="text-danger font-size-sm">
                        <span>{{'Level3approverisrequired'| localize}}</span>
                    </div>
                </div>
                <div class="mt-3 text-muted">{{'ApprovalWindow' | localize}}<span class="required text-danger"></span> </div>
                <div class="d-flex">
                    <!--approval window-->
                    <div class="w-100">
                        <div class="">
                            <input type="number" (keypress)="onlyNumberKey($event)" class="form-control" required
                                   name="apprWin3" (input)="emitdata()" min="0" #apprWin3="ngModel" placeholder="{{'Select Approval' | localize}}"
                                   [(ngModel)]="projectTimeOff.approvalWindowThree"
                                   [ngClass]="{ 'red-border': !projectTimeOff.approvalWindowThree && projectFormSubmitted && !Level3Approver?.id }">
                        </div>
                        <div id="error-message" class="text-danger font-size-sm" *ngIf="!projectTimeOff.approvalWindowThree && projectFormSubmitted && !Level3Approver?.id">{{'ApprovalWindowismandatory'| localize}}</div>
                    </div>

                    <label class="pr-4 pl-4 pt-2">{{'in' | localize }}</label>

                    <div class="w-100" id="window">
                        <!--approval window type-->
                        <ng-select [items]="WindowEnum" bindValue="id" bindLabel="name"
                                   [(ngModel)]="projectTimeOff.approvalWindowInThree"
                                   [ngClass]="{ 'red-border': !projectTimeOff.approvalWindowInThree && projectFormSubmitted  && !Level3Approver?.id }"
                                   placeholder="{{'SelectWindowType' | localize}}" (change)="emitdata()" required>
                            <ng-template ng-option-tmp let-item="item">
                                {{item?.name | localize}}
                            </ng-template>
                        </ng-select>
                        <div id="error-message" class="text-danger font-size-sm" *ngIf="!projectTimeOff.approvalWindowInThree && projectFormSubmitted  && !Level3Approver?.id">{{'WindowTypeismandatory' | localize}}</div>
                    </div>
                </div>

                <div *ngIf="Level3Approver != null" class="border p-2 mt-5 rounded">

                    <div class="row">
                        <div class="col-2 d-flex justify-content-center align-items-center rounded w-40px h-40px">
                            <img src="{{ Level3Approver?.profileImage ? Level3Approver?.profileImage : 'assets/common/images/default-profile-picture1.svg' }}"
                                 class="w-35px h-35px img-fluid rounded border border-light p-1" id="profimgsize">
                        </div>
                        <div class=" col-9 d-flex align-items-start justify-content-center flex-column text-dark-75">
                            <div class="font-weight-bold " pTooltip="{{ getFullname(Level3Approver?.name, Level3Approver?.surname) }}" [tooltipDisabled]="false"
                                 tooltipPosition="bottom">{{ getFullname(Level3Approver?.name, Level3Approver?.surname) | slice:0:25}}{{getFullname(Level3Approver?.name, Level3Approver?.surname).length > 25 ? '...' : ''}}</div>

                            <div pTooltip="{{ Level3Approver?.emailAddress }}" tooltipPosition="bottom" class="div-styl2"
                                 [tooltipDisabled]="(Level3Approver?.emailAddress) | tooltipDisabled:25">{{  Level3Approver?.emailAddress  | slice:0:25}}{{  Level3Approver?.emailAddress?.length > 25 ? '...' : '' }}</div>
                        </div>
                        <div class="col-1 px-0 py-3 cursor-pointer">
                            <img class="cursor-pointer" (click)="Level3Approver=null;emitdata()"
                                 src="assets/common/images/projects/Delete_Icon.svg" width="15" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group col-md-12" id="Level4" *ngIf="displayLevel > 3 || Level4Approver && projectTimeOff.approvalWindowFour && projectTimeOff.approvalWindowInFour">

                <label class="level font-weight-bolder">
                    {{ 'Level' | localize }} 4<span class="required text-danger"></span>
                </label>
                <div class="float-right rigth-div cursor-pointer" style="z-index: 6;">
                    <button type="button" (click)="removeAprroverLevel();Level4Approver=null;emitdata()"
                            class="border-0 text-danger">
                        <i class="la la-times text-danger font-weight-bold"></i>
                    </button>
                </div>
                <!--Level one approver dropdown-->
                <div id="levelFour">
                    <ng-select class="width-percent-100 p-0" name="Level4Approver" [(ngModel)]="Level4Approver"
                               [multiple]="false" (change)="emitdata()"
                               [ngClass]="{ 'red-border': !Level4Approver && projectFormSubmitted }"
                               #levelTwo="ngModel"
                               placeholder="{{'SelectApprover' | localize}}">
                        <ng-option [value]="item" *ngFor="let item of filteredUsers; trackBy: trackByName">
                            <div class="d-flex">
                                <div class="d-flex justify-content-center align-items-center rounded bg-light mx-1">
                                    <img src="{{ item?.profileImage ? item?.profileImage : 'assets/common/images/default-profile-picture1.svg' }}"
                                         class="img-fluid border border-light rounded h-40px w-40px p-1" id="profimgsize">
                                </div>

                                <div class="justify-content-center ml-2 mr-4 ">
                                    <div class=" font-weight-bold font-size-13">
                                        <span pTooltip="{{ item?.name}} {{item?.surname}}"
                                              [tooltipDisabled]="item?.name?.length < 17"
                                              tooltipPosition="bottom">{{ item?.name?.length > 17  ? item?.name?.slice(0,17)+'...': item?.name +' ' +item?.surname|titlecase}}</span>

                                    </div>

                                    <div class="flex-column justify-content-start align-self-center font-weight-bold font-size-14" pTooltip="{{  item?.emailAddress}}"
                                         [tooltipDisabled]="item?.emailAddress?.length<28"
                                         tooltipPosition="bottom">

                                        {{ item?.emailAddress?.length>28 ? item?.emailAddress.slice(0,28)+'...': item?.emailAddress}}
                                    </div>
                                </div>
                            </div>
                        </ng-option>
                        <ng-template ng-label-tmp let-item="item">
                            <span class="d-flex align-items-center">
                                <img class="mr-1 w-35px h-35px img-fluid rounded bg-primary-o-40 p-1"
                                     [src]="item?.profileImage ? item?.profileImage : 'assets/common/images/default-profile-picture1.svg'" />
                                {{item?.name}}
                            </span>
                        </ng-template>
                    </ng-select>
                    <div *ngIf="!Level4Approver && projectFormSubmitted" class="text-danger div-style font-size-sm">
                        <span>{{'Level4approverisrequired'| localize}}</span>
                    </div>
                </div>
                <div class="mt-3 text-muted">{{'ApprovalWindow' | localize}}<span class="required text-danger"></span> </div>
                <div class="d-flex">
                    <!--approval window-->
                    <div class="w-100">
                        <div class="">
                            <input type="number" (keypress)="onlyNumberKey($event)" class="form-control" required
                                   name="apprWin4" (input)="emitdata()" min="0" #apprWin4="ngModel" placeholder="{{'Select Approval' | localize}}"
                                   [(ngModel)]="projectTimeOff.approvalWindowFour"
                                   [ngClass]="{ 'red-border': !projectTimeOff.approvalWindowFour && projectFormSubmitted && !Level4Approver?.id }">
                        </div>
                        <div id="error-message" class="text-danger font-size-sm" *ngIf="!projectTimeOff.approvalWindowFour && projectFormSubmitted && !Level4Approver?.id">{{'ApprovalWindowismandatory'| localize}}</div>

                    </div>

                    <label class="pr-4 pl-4 pt-2">{{'in' | localize }}</label>

                    <div class="w-100" id="window">
                        <!--approval window type-->
                        <ng-select [items]="WindowEnum" bindValue="id" bindLabel="name"
                                   [(ngModel)]="projectTimeOff.approvalWindowInFour"
                                   [ngClass]="{ 'red-border': !projectTimeOff.approvalWindowInFour && projectFormSubmitted  && !Level4Approver?.id }"
                                   placeholder="{{'SelectWindowType' | localize}}" (change)="emitdata()" required>
                            <ng-template ng-option-tmp let-item="item">
                                {{item?.name | localize}}
                            </ng-template>
                        </ng-select>
                        <div id="error-message" class="text-danger font-size-sm" *ngIf="!projectTimeOff.approvalWindowInFour && projectFormSubmitted  && !Level4Approver?.id">{{'WindowTypeismandatory' | localize}}</div>
                    </div>
                </div>

                <div *ngIf="Level4Approver != null" class="border p-2 mt-5 rounded">

                    <div class="row">
                        <div class="col-2 d-flex justify-content-center align-items-center rounded w-40px h-40px">
                            <img src="{{ Level4Approver?.profileImage ? Level4Approver?.profileImage : 'assets/common/images/default-profile-picture1.svg' }}"
                                 class="w-35px h-35px img-fluid rounded border border-light p-1" id="profimgsize">
                        </div>
                        <div class=" col-9 d-flex align-items-start justify-content-center flex-column text-dark-75">
                            <div class="font-weight-bold " pTooltip="{{ getFullname(Level4Approver?.name, Level4Approver?.surname) }}" [tooltipDisabled]="false"
                                 tooltipPosition="bottom">{{ getFullname(Level4Approver?.name, Level4Approver?.surname) | slice:0:25}}{{getFullname(Level4Approver?.name, Level4Approver?.surname).length > 25 ? '...' : ''}}</div>

                            <div pTooltip="{{ Level4Approver?.emailAddress }}" tooltipPosition="bottom" class="div-styl2"
                                 [tooltipDisabled]="(Level4Approver?.emailAddress) | tooltipDisabled:25">{{  Level4Approver?.emailAddress  | slice:0:25}}{{  Level4Approver?.emailAddress?.length > 25 ? '...' : '' }}</div>
                        </div>
                        <div class="col-1 px-0 py-3 cursor-pointer">
                            <img class="cursor-pointer" (click)="Level4Approver=null;emitdata()"
                                 src="assets/common/images/projects/Delete_Icon.svg" width="15" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group col-md-12" id="Level5" *ngIf="displayLevel > 4 || Level4Approver && projectTimeOff.approvalWindowFour && projectTimeOff.approvalWindowInFour">

                <label class="level font-weight-bolder">
                    {{ 'Level' | localize }} 5<span class="required text-danger"></span>
                </label>
                <div class="float-right rigth-div cursor-pointer" style="z-index: 6;">
                    <button type="button" (click)="removeAprroverLevel();Level5Approver=null;emitdata()"
                            class="border-0 text-danger">
                        <i class="la la-times text-danger font-weight-bold"></i>
                    </button>
                </div>
                <!--Level one approver dropdown-->
                <div id="levelFour">
                    <ng-select class="width-percent-100 p-0" name="Level5Approver" [(ngModel)]="Level4Approver"
                               [multiple]="false" (change)="emitdata()"
                               [ngClass]="{ 'red-border': !Level5Approver && projectFormSubmitted }"
                               #levelTwo="ngModel"
                               placeholder="{{'SelectApprover' | localize}}">
                        <ng-option [value]="item" *ngFor="let item of filteredUsers; trackBy: trackByName">
                            <div class="d-flex">
                                <div class="d-flex justify-content-center align-items-center rounded bg-light mx-1">
                                    <img src="{{ item?.profileImage ? item?.profileImage : 'assets/common/images/default-profile-picture1.svg' }}"
                                         class="img-fluid border border-light rounded h-40px w-40px p-1" id="profimgsize">
                                </div>

                                <div class="justify-content-center ml-2 mr-4 ">
                                    <div class=" font-weight-bold font-size-13">
                                        <span pTooltip="{{ item?.name}} {{item?.surname}}"
                                              [tooltipDisabled]="item?.name?.length < 17"
                                              tooltipPosition="bottom">{{ item?.name?.length > 17  ? item?.name?.slice(0,17)+'...': item?.name +' ' +item?.surname|titlecase}}</span>

                                    </div>

                                    <div class="flex-column justify-content-start align-self-center font-weight-bold font-size-14" pTooltip="{{  item?.emailAddress}}"
                                         [tooltipDisabled]="item?.emailAddress?.length<28"
                                         tooltipPosition="bottom">

                                        {{ item?.emailAddress?.length>28 ? item?.emailAddress.slice(0,28)+'...': item?.emailAddress}}
                                    </div>
                                </div>
                            </div>
                        </ng-option>
                        <ng-template ng-label-tmp let-item="item">
                            <span class="d-flex align-items-center">
                                <img class="mr-1 w-35px h-35px img-fluid rounded bg-primary-o-40 p-1"
                                     [src]="item?.profileImage ? item?.profileImage : 'assets/common/images/default-profile-picture1.svg'" />
                                {{item?.name}}
                            </span>
                        </ng-template>
                    </ng-select>
                    <div *ngIf="!Level5Approver && projectFormSubmitted" class="text-danger  font-size-sm">
                        <span>{{'Level5approverisrequired'| localize}}</span>
                    </div>
                </div>
                <div class="mt-3 text-muted">{{'ApprovalWindow' | localize}}<span class="required text-danger"></span> </div>
                <div class="d-flex">
                    <!--approval window-->
                    <div class="w-100">
                        <div class="">
                            <input type="number" (keypress)="onlyNumberKey($event)" class="form-control" required
                                   name="apprWin4" (input)="emitdata()" min="0" #apprWin4="ngModel" placeholder="{{'Select Approval' | localize}}"
                                   [(ngModel)]="projectTimeOff.approvalWindowFive"
                                   [ngClass]="{ 'red-border': !projectTimeOff.approvalWindowFive && projectFormSubmitted && !Level5Approver?.id  }">
                        </div>
                        <div id="error-message" class="text-danger font-size-sm" *ngIf="!projectTimeOff.approvalWindowFive && projectFormSubmitted && !Level5Approver?.id">{{'ApprovalWindowismandatory'| localize}}</div>

                    </div>

                    <label class="pr-4 pl-4 pt-2">{{'in' | localize }}</label>

                    <div class="w-100" id="window">
                        <!--approval window type-->
                        <ng-select [items]="WindowEnum" bindValue="id" bindLabel="name"
                                   [(ngModel)]="projectTimeOff.approvalWindowInFive"
                                   [ngClass]="{ 'red-border': !projectTimeOff.approvalWindowInFive && projectFormSubmitted  && !Level5Approver?.id }"
                                   placeholder="{{'SelectWindowType' | localize}}" (change)="emitdata()" required>
                            <ng-template ng-option-tmp let-item="item">
                                {{item?.name | localize}}
                            </ng-template>
                        </ng-select>
                        <div id="error-message" class="text-danger font-size-sm" *ngIf="!projectTimeOff.approvalWindowInFive && projectFormSubmitted  && !Level5Approver?.id">{{'WindowTypeismandatory' | localize}}</div>
                    </div>
                </div>

                <div *ngIf="Level4Approver != null" class="border p-2 mt-5 rounded">

                    <div class="row">
                        <div class="col-2 d-flex justify-content-center align-items-center rounded w-40px h-40px">
                            <img src="{{ Level5Approver?.profileImage ? Level5Approver?.profileImage : 'assets/common/images/default-profile-picture1.svg' }}"
                                 class="w-35px h-35px img-fluid rounded border border-light p-1" id="profimgsize">
                        </div>
                        <div class=" col-9 d-flex align-items-start justify-content-center flex-column text-dark-75">
                            <div class="font-weight-bold " pTooltip="{{ getFullname(Level5Approver?.name, Level5Approver?.surname) }}" [tooltipDisabled]="false"
                                 tooltipPosition="bottom">{{ getFullname(Level5Approver?.name, Level5Approver?.surname) | slice:0:25}}{{getFullname(Level5Approver?.name, Level5Approver?.surname).length > 25 ? '...' : ''}}</div>

                            <div pTooltip="{{ Level5Approver?.emailAddress }}" tooltipPosition="bottom" class="div-styl2"
                                 [tooltipDisabled]="(Level5Approver?.emailAddress) | tooltipDisabled:25">{{  Level5Approver?.emailAddress  | slice:0:25}}{{  Level5Approver?.emailAddress?.length > 25 ? '...' : '' }}</div>
                        </div>
                        <div class="col-1 px-0 py-3 cursor-pointer">
                            <img class="cursor-pointer" (click)="Level5Approver=null;emitdata()"
                                 src="assets/common/images/projects/Delete_Icon.svg" width="15" />
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col-md-12 d-flex justify-content-between">
                <div class="col-4" *ngIf="displayLevel < 5">
                    <a class=" text-primary font-12 project-curser" (click)="addAprroverLevel()">
                        <i class="fa fa-plus fa-1x text-primary pr-1"></i>{{('Add level' | localize)}}
                    </a>
                </div>
            </div>
        </div>
    </form>
</div>
